import { useState, useRef, useEffect } from "react";
import "../WarningStack/WarningStack.css";
import { Tooltip } from "@mui/material";
import warning_icon from '../../../common/assets/images/errormark.png'

const WarningStack = ({ warnings }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!warnings?.length) return null;

  const first = warnings[0];
  const remaining = warnings.slice(1);
const getMessage = (w) => {
  if (typeof w === "string") return w;
  return w?.message || "";
};
  return (
    <div className="warnings-container" ref={ref}>
      {/* ALWAYS VISIBLE */}
      <div
        className="warning-main"
        onClick={() => setOpen(!open)}
      >
       {getIcon(first.type)}
   
<Tooltip  title={getMessage(first)}>
<span className="ellipsis-message">{getMessage(first)}</span>
</Tooltip>

        {remaining.length > 0 && (
          <span className="more">+{remaining.length}</span>
        )}
      </div>

      {/* FLOATING DROPDOWN */}
      {open && (
        <div className="warning-dropdown">
          {warnings.map((w, i) => (
            <div key={i} className="warning-item">
              <span>{getIcon(w.type)}</span>
              <span>{w.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const getIcon = (type) => {
  if (type === "error") {
    return <span className="icon error">⛔</span>;
  }
  if (type === "warning") {
    return <span className="icon warning"><img src={warning_icon} alt="warning" style={{ height: "15px" }} /></span>;
  }
  return <span className="icon info">{""}</span>;
};

export default WarningStack;